// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "6544") return "6544.3beb46ea1.bundle.js";
  // return url for filenames based on template
  return "" + (chunkId === "3992" ? "pagerules" : chunkId) + ".3beb46ea1.chunk.js"
}